import Vue from 'vue'

const currency = {
    install(Vue) {
        Vue.filter('currency', function (input) {
            if (!input) { return "0.00"; }
            if (isNaN(input)) { return "0.00"; }
            input = parseFloat(input);
            if (input % 1 === 0) {
                input = input.toFixed(2);
            }
            else {
                input = input.toFixed(2);
            }
            return input.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        })
    }
}

Vue.use(currency)